import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Award } from 'lucide-react';

// PM Skorlama Plan 5, Task 2 — "Nihai Seviyem" kartı. DTO-driven: `finalLevelLabel`
// yalnız BE'nin tebliğ koşulu sağlandığında (period.DiscloseFinalLevel && period.
// Status=="closed" && CalibrationRecord.FinalLevelId != null — bkz. Task 1 raporu)
// JSON'da gelir; aksi halde MyPeriodResultsPage bu prop'a `null` geçirir. FE bu
// koşulu KENDİSİ HESAPLAMAZ — prop yoksa (null/undefined) bileşen hiçbir şey render
// etmez (KVKK: sızıntı yok, tebliğ kapalıyken bu bileşenin izine bile rastlanmaz).
const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 16px;
`;

const IconWrap = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.bgColor};
  color: ${({ theme }) => theme.colors.primary.main};
`;

const Body = styled.div`
  flex: 1;
`;

const CardTitle = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin-bottom: 2px;
`;

const LevelValue = styled.div`
  font-size: 22px;
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.primary.main};
`;

const Note = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin-top: 6px;
`;

export default function FinalLevelCard({ finalLevelLabel }) {
  const { t } = useTranslation();

  if (!finalLevelLabel) return null;

  return (
    <Card data-role="final-level-card">
      <IconWrap><Award size={22} /></IconWrap>
      <Body>
        <CardTitle>{t('performance.myResults.finalLevelCard.title')}</CardTitle>
        <LevelValue data-role="final-level-value">{finalLevelLabel}</LevelValue>
        <Note>{t('performance.myResults.finalLevelCard.disclosedNote')}</Note>
      </Body>
    </Card>
  );
}
